'use es6';

import PropTypes from 'prop-types';
import { Children, PureComponent } from 'react';
import styled from 'styled-components';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import { getBackgroundColor } from 'conversations-message-history/primary-message/operators/themeGetters';
import ThemeContext from 'conversations-message-history/primary-message/provider/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
const PaddedArea = styled.div.attrs({
  'data-test-id': 'primary-message-body-content'
}).withConfig({
  displayName: "PrimaryMessageContentSection__PaddedArea",
  componentId: "cwcuj3-0"
})(["padding:0;"]);
export const PrimaryMessageContentSectionWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageContentSection__PrimaryMessageContentSectionWrapper",
  componentId: "cwcuj3-1"
})(["width:100%;button{width:auto;}"]);
export default class PrimaryMessageContentSection extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.isLastMessage
    };
    this.onCollapseButtonClick = this.onCollapseButtonClick.bind(this);
    this.expandMessage = this.expandMessage.bind(this);
  }
  onCollapseButtonClick() {
    this.setState({
      expanded: false
    });
  }
  expandMessage() {
    if (!this.state.expanded) {
      this.setState({
        expanded: true
      });
    }
  }
  renderContent() {
    const {
      canExpand,
      children
    } = this.props;
    const {
      expanded
    } = this.state;
    if (!canExpand) {
      return /*#__PURE__*/_jsx(PaddedArea, {
        children: children
      });
    }
    return /*#__PURE__*/_jsx(UIExpandableText, {
      gradientColor: getBackgroundColor(this.context),
      onCollapseButtonClick: this.onCollapseButtonClick,
      expanded: expanded,
      maxHeight: 250,
      children: /*#__PURE__*/_jsx(PaddedArea, {
        children: children
      })
    });
  }
  render() {
    const {
      canExpand,
      children,
      className
    } = this.props;
    const hasContent = Children.count(children) > 0;
    if (!hasContent) {
      return null;
    }
    return /*#__PURE__*/_jsx(PrimaryMessageContentSectionWrapper, {
      className: className,
      children: /*#__PURE__*/_jsx("div", {
        onClick: canExpand ? this.expandMessage : () => {},
        className: "width-100 padding-x-4 padding-y-2",
        children: this.renderContent()
      })
    });
  }
}
PrimaryMessageContentSection.contextType = ThemeContext;
PrimaryMessageContentSection.displayName = 'PrimaryMessageContentSection';
PrimaryMessageContentSection.propTypes = {
  canExpand: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  isLastMessage: PropTypes.bool
};